
import { registerLocaleData } from "@angular/common";
import { NgModule } from "@angular/core";

import { AuthenticateXHRBackend } from "./authenticate-xhr.backend";
import { XHRBackend } from "@angular/http";

import { AppComponent } from "./app.component";

/* Modules */
import { AccountModule } from "./modules/account/account.module";
import { VisitasModule } from "./modules/visitas/visitas.module";
import { ClientesModule } from "./modules/clientes/clientes.module";
import { CoreModule } from './core/core.module'

import {FormsModule} from '@angular/forms';
import {MatTabsModule} from '@angular/material/tabs';

/*End Modules */

import localeBr from "@angular/common/locales/pt";

registerLocaleData(localeBr);

import { ConfigService } from "./shared/utils/config.service";

import { ScreenLoadingService } from '@core/services/screen-loading.service';
//import { ParametrizacaoComponent } from './modules/parametrizacao/pages/parametrizacao/parametrizacao.component';
import { ParametrizacaoModule } from "@modules/parametrizacao/parametrizacao.module";
import { CartaoModule } from "@modules/cartao/cartao.module";
import { VideoModule } from "@modules/videos/video.module";

@NgModule({
  declarations: [AppComponent, ],
  imports: [
    AccountModule,
    VisitasModule,
    ClientesModule,
    ParametrizacaoModule,
    CartaoModule,
    CoreModule,
    FormsModule,
    MatTabsModule,
    VideoModule
    
  
  ],
  providers: [
    ConfigService,
    ScreenLoadingService,
    { provide: XHRBackend, useClass: AuthenticateXHRBackend }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
